import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { Location } from '../../../../app/models/Location';

type Props = {
    locationDataForm: Location;
    setLocationDataForm: (location: Location) => void;
    errorFields?: any;
};

const LocationForm = ({ locationDataForm, setLocationDataForm, errorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        // Manejar campos numéricos (latitud y longitud)
        if (name === 'latitude' || name === 'longitude') {
            const numValue = value === '' ? null : parseFloat(value);
            setLocationDataForm({ ...locationDataForm, [name]: isNaN(numValue as number) ? null : numValue });
        } else {
            setLocationDataForm({ ...locationDataForm, [name]: value });
        }
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Nombre</label>
                <div className="col-md-9">
                    <input
                        name="name"
                        id="name"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={locationDataForm.name}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('name')}
                        placeholder="Ingrese el nombre de la ubicación"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('name')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Descripción</label>
                <div className="col-md-9">
                    <textarea
                        name="description"
                        id="description"
                        rows={3}
                        className={`form-control ${fieldHasError('description')}`}
                        value={locationDataForm.description || ''}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('description')}
                        placeholder="Ingrese una descripción (opcional)"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('description')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Latitud</label>
                <div className="col-md-9">
                    <input
                        name="latitude"
                        id="latitude"
                        type="number"
                        step="any"
                        className={`form-control ${fieldHasError('latitude')}`}
                        value={locationDataForm.latitude ?? ''}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('latitude')}
                        placeholder="Ingrese la latitud (opcional)"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('latitude')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Longitud</label>
                <div className="col-md-9">
                    <input
                        name="longitude"
                        id="longitude"
                        type="number"
                        step="any"
                        className={`form-control ${fieldHasError('longitude')}`}
                        value={locationDataForm.longitude ?? ''}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('longitude')}
                        placeholder="Ingrese la longitud (opcional)"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('longitude')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default LocationForm;
